import Configuration from '@/agilis/util/Configuration'
import FormTree from '@/agilis/components/Form/FormTree/FormTree.js'
import L from 'lodash'
import { mapActions } from 'vuex/dist/vuex.common.js'

function walkTree (nodeId) {
  const tmp = nodeId.split('-')
  const output = []

  tmp.forEach((id, index) => {
    output.push(
      tmp.slice(0, index + 1).join('-')
    )
  })

  return output
}

export default {
  name: 'AreaTree',
  mixins: [FormTree],

  watch: {
    value (newValue, oldValue) {
      this.innerValue = newValue // react to changes in input prop

      this.$emit('component-update', this.findNode(newValue))

      if (newValue) { // Set inner vars when values arrives after the creation of the component
        this.selectedNodes = [this.value]
        this.openNodes = walkTree(this.value)
        this.activeNodes = [this.value]
      }
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError'
    }),
    async fetchTree () {
      this.loading = true
      if (this.fieldConfig.url || this.fieldConfig.api) {
        if (this.fetchData && typeof this.fetchData === 'function') {
          this.tree = await this.fetchData()
        }
      } else {
        if (this.loadTree && typeof this.loadTree === 'function') {
          this.tree = await this.loadTree()
        }
      }
      this.loading = false
    },

    async fetchData () {
      const api = this.$axios.agilisComputeApiProp(this.fieldConfig)

      if (!api.url) {
        return
      }

      try {
        const response = await this.$axios({
          ...api.config,
          method: api.method,
          url: api.url,
          data: api.body
        })

        return this.fetchOptions(response.data)
      } catch (error) {
        this.notifyError(error)
      }
    },

    loadTree () {
      const trackerType = Configuration.getTrackerType(this.applicationId, 'priceItem')
      return this.fetchOptions(trackerType.optionsArea)
    },

    fetchOptions (options) {
      return (Object.values(options || {}).map((l) => {
        return {
          id: l.id,
          name: this.$t(l.name),
          workpackages: l.workpackages ? l.workpackages : undefined,
          children: l.options ? this.fetchOptions(l.options) : undefined
        }
      }))
    },

    findNode (nodeId) {
      const node = L.findDeep(
        this.tree,
        (value, key) => {
          if (key === 'id' && value === nodeId) {
            return true
          }
        }
      )

      if (node) {
        return node.parent
      }
    }
  }
}
